import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ps9pnmcgk: FaireProductEntity = {
  token: "p_9ps9pnmcgk",
  type: "product",
  name: "OY Small Coffee Table in Dark",
  brandToken: "b_8qfvgpu7nc",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/495a85e25f66742ac4703e47450d74d789d6ec4041785cd6ce3e61d6533d84e6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30e29d168b4b57328720b5813f62d54af3e330175dd2950ba6236c3b621d5b75.jpeg",
    "https://cdn.faire.com/fastly/223384dcf2bc3892bfa56ce31adcc3b4c83090d0783db59290712f73bb8bd896.jpeg",
    "https://cdn.faire.com/fastly/ce995950e451ea387b7663f01b537fce6f4862ba3935ae4e2c50cba3ab656670.jpeg",
  ],
  priceDollars: 172.55,
  description:
    'Inspired by sculptural minimalism the OY Coffee Table is designed with an eye on simplicity with an edge. Seen from above, the joints of the table top and the angular legs form an O and an Y, which is why it’s named the OY Coffee Table. The table is crafted in high-quality ash treated with a stained oil giving a depth and warmth which emphasizes the elegant and natural veining of the wood. Use multiple OY Coffee Tables in different sizes to create a cohesive landscape in two levels.\n\nProduct Overview\n\n * Color: Dark \n * Dimensions: 25.59"Dia x 14.17"H\n\n * Material: Stained Ash/Stained Ash Veneer ',
  tags: [],
  msrpDollars: 345.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:37.991Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
